import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IChangeStressResponse,
  IChangeStressPayload,
} from "models/stressCheck/changeStress";
import { httpStatus } from "configs/httpStatus";
import { getChangeStress } from "services/stressCheck";
import { handleSuccesAction, handleErrorAction } from "./changeStressActions";

function* changeStressSaga({ payload }: { payload: IChangeStressPayload }) {
  try {
    const response: IChangeStressResponse = yield call(
      getChangeStress,
      payload
    );

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onChangeStressWatcher() {
  yield takeLatest(ActionType.CHANGE_STRESS as any, changeStressSaga);
}

export default [fork(onChangeStressWatcher)];
